import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicLayout from "./components/layout/PublicLayout";

import Home from "./pages/Home";
import Sermons from "./pages/Sermons";
import Events from "./pages/Events";
import Giving from "./pages/Giving";
import JoinTeam from "./pages/JoinTeam";
import Membership from "./pages/Membership";
import BibleSchool from "./pages/BibleSchool";
import Locations from "./pages/Locations";
import Counselling from "./pages/Counselling";
import Homecell from "./pages/Homecell";
import Youth from "./pages/Youth";
import Prayers from "./pages/Prayers";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout, { AdminOverview } from "./pages/AdminLayout";
import AdminEvents from "./pages/AdminEvents";
import AdminSermons from "./pages/AdminSermons";
import AdminEBI from "./pages/AdminEBI";
import { AdminMemberships, AdminJoinTeam } from "./pages/AdminSubmissions";
import { AdminCounselling, AdminHomecell } from "./pages/AdminCare";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/sermons" element={<Sermons />} />
            <Route path="/events" element={<Events />} />
            <Route path="/giving" element={<Giving />} />
            <Route path="/join-team" element={<JoinTeam />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/bible-school" element={<BibleSchool />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/counselling" element={<Counselling />} />
            <Route path="/homecell" element={<Homecell />} />
            <Route path="/youth" element={<Youth />} />
            <Route path="/prayers" element={<Prayers />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminOverview />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="sermons" element={<AdminSermons />} />
            <Route path="memberships" element={<AdminMemberships />} />
            <Route path="join-team" element={<AdminJoinTeam />} />
            <Route path="bible-school" element={<AdminEBI />} />
            <Route path="counselling" element={<AdminCounselling />} />
            <Route path="homecell" element={<AdminHomecell />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
